import { render, staticRenderFns } from "./CoachProfileCreate.vue?vue&type=template&id=55f02458"
import script from "./CoachProfileCreate.vue?vue&type=script&lang=js"
export * from "./CoachProfileCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports